import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import RectangleBox, { RectangleBoxItem } from '../RectangleBox';
import CustomButton from '../../UI/CustomButton';
import { typeMappingHandler } from '../../../constants/keysMapping';
import CliftonDialog from './Dialog';
import ChartBar from './ChartBar';
import './clifton.scss';

interface CliftonProps {
  cilifton: any;
  exporting?: boolean;
  cliftonRef?: any;
}

const Clifton: React.FC<CliftonProps> = (props) => {
  const { cilifton, exporting, cliftonRef } = props;
  const { EG1, EG2, EG3, EG4, Emax, Emin } = cilifton;
  const [openCliftonDialog, setOpenCliftonDialog] = useState<boolean>(false);

  const chartData = [EG1.score, EG2.score, EG3.score, EG4.score];

  const EmaxArray = Object.entries(Emax)
    .map((item) => {
      return {
        key: item[0],
        value: item[1],
        color: typeMappingHandler(item[0]).color,
      };
    })
    .sort((a: any, b: any) => b.value - a.value);

  const EminArray = Object.entries(Emin)
    .map((item) => {
      return {
        key: item[0],
        value: item[1],
        color: typeMappingHandler(item[0]).color,
      };
    })
    .sort((a: any, b: any) => a.value - b.value);

  const EG1Array = Object.entries(EG1.result)
    .map((item: any) => {
      return {
        key: item[0],
        value: item[1],
      };
    })
    .sort((a: any, b: any) => b.value - a.value);

  const EG2Array = Object.entries(EG2.result)
    .map((item: any) => {
      return {
        key: item[0],
        value: item[1],
      };
    })
    .sort((a: any, b: any) => b.value - a.value);

  const EG3Array = Object.entries(EG3.result)
    .map((item: any) => {
      return {
        key: item[0],
        value: item[1],
      };
    })
    .sort((a: any, b: any) => b.value - a.value);

  const EG4Array = Object.entries(EG4.result)
    .map((item: any) => {
      return {
        key: item[0],
        value: item[1],
      };
    })
    .sort((a: any, b: any) => b.value - a.value);

  useEffect(() => {
    if (exporting) {
      setOpenCliftonDialog(true);
      setTimeout(() => {
        setOpenCliftonDialog(false);
      }, 3_000);
    }
  }, [exporting]);

  return (
    <Box className='mainCliftonContainer'>
      <Box className='header'>
        <Box className='flexCenter' gap={1}>
          <Typography color='text.main' fontWeight='bold'>
            استعداد ها
          </Typography>

          <Box bgcolor='background.light' className='labelBox'>
            <Typography>Clifton</Typography>
          </Box>
        </Box>

        {!exporting && (
          <CustomButton variant='outlined' onClick={() => setOpenCliftonDialog(true)}>
            <Typography>دیدن جزییات</Typography>
          </CustomButton>
        )}
      </Box>

      <Grid container>
        <Grid item xl={4} lg={12} p={1}>
          <Typography color='text.main' fontWeight='bold'>
            نقاط قوت
          </Typography>

          {EmaxArray.map((item: any, index: number) => (
            <RectangleBox
              key={item.key}
              label={typeMappingHandler(item.key).message}
              bgColor={item.color}
              index={index}
            />
          ))}

          <Typography color='text.main' fontWeight='bold' mt={2}>
            نقاط ضعف
          </Typography>

          {EminArray.map((item: any, index: number) => (
            <RectangleBox
              key={item.key}
              label={typeMappingHandler(item.key).message}
              bgColor={item.color}
              index={index}
            />
          ))}
        </Grid>
        <Grid item xl={8} lg={12} p={1}>
          <Typography color='text.main' fontWeight='bold' mt={3}>
            میانگین امتیاز برای کروه استعداد
          </Typography>

          <Box className='chartContainer'>
            <ChartBar
              chartData={chartData}
              labels={[
                typeMappingHandler('EG1').message,
                typeMappingHandler('EG2').message,
                typeMappingHandler('EG3').message,
                typeMappingHandler('EG4').message,
              ]}
            />
          </Box>
        </Grid>
      </Grid>

      <CliftonDialog
        cliftonRef={cliftonRef}
        exporting={exporting}
        openCliftonDialog={openCliftonDialog}
        setOpenCliftonDialog={() => setOpenCliftonDialog(false)}
        EG1={EG1Array}
        EG2={EG2Array}
        EG3={EG3Array}
        EG4={EG4Array}
      />
    </Box>
  );
};

export default Clifton;
